import { useTheme } from '@approvalmax/theme';
import { Spacing, useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { getInnerActivePageId } from 'modules/common/selectors/navigationSelectors';
import { SimplePageLayout } from 'modules/page';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useMedia } from 'react-use';

import { PAGE_ID, PROFILE_SETUP_SSO_PAGE_ID } from '../../config';
import { getDocumentTitle } from '../../selectors/pageSelectors';
import MobileLogo from '../FirstTimeSetupPage/components/MobileLogo/MobileLogo';
import { useProfileSetupSsoPageData } from './ProfileSetupSsoPage.hooks';
import { PageContent, StyledSignUpConsentPopup } from './ProfileSetupSsoPage.styles';

/**
 * @deprecated Use Redesigned version
 */
const ProfileSetupSsoPage = memo(() => {
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const innerActivePageId = useSelector(getInnerActivePageId);
    const documentTitle = useSelector(getDocumentTitle);

    useLayout({ containerMinSize: 'xxsmall' });
    useProfileSetupSsoPageData();

    const { theme } = useTheme();
    const isMobileScreen = useMedia(`(max-width: ${theme.container.breakpoint.xsmall})`);

    if (innerActivePageId !== PROFILE_SETUP_SSO_PAGE_ID || activePageId !== PAGE_ID) {
        return <SimplePageLayout />;
    }

    return (
        <SimplePageLayout documentTitle={documentTitle} enableMobileAdaptive>
            <PageContent>
                {isMobileScreen && (
                    <>
                        <Spacing height={40} />

                        <MobileLogo />
                    </>
                )}

                <StyledSignUpConsentPopup />
            </PageContent>
        </SimplePageLayout>
    );
});

ProfileSetupSsoPage.displayName = 'ProfileSetupSsoPage';

export default ProfileSetupSsoPage;
